var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card user-card"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container404"},[_c('h1',[_vm._v("403")]),_c('p',[_vm._v("对不起，您尝试访问的页面目前对您不可用")]),_c('p',[_vm._v("这可能是由于以下原因之一：")]),_c('ul',[_c('li',[_vm._v("您没有足够的权限来查看此页面。")]),_c('li',[_vm._v("您的会话可能已过期，请尝试重新登录。")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }